// SSTOA API 호출 래퍼 — 외부 HTTP 라이브러리 없이 fetch 만 사용.
// Authorization: Bearer 자동 부착, 401 이면 토큰 삭제 후 로그인으로.

const BASE = "/api/sstoa";
const TOKEN_KEY = "sstoa_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}
export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

function redirectToLogin() {
  clearToken();
  if (window.location.pathname !== "/sstoa/login") {
    window.location.assign("/sstoa/login");
  }
}

async function request(path, { method = "GET", body, isForm = false } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  let payload;
  if (isForm) {
    payload = body; // FormData — Content-Type 은 브라우저가 boundary 와 함께 지정
  } else if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }

  const res = await fetch(`${BASE}${path}`, { method, headers, body: payload });

  if (res.status === 401) {
    redirectToLogin();
    throw new Error("로그인이 필요합니다.");
  }

  if (res.status === 204) return null;

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = typeof data.detail === "string" ? data.detail : "요청에 실패했습니다.";
    throw new Error(detail);
  }
  return data;
}

export const api = {
  get: (p) => request(p),
  post: (p, body) => request(p, { method: "POST", body }),
  put: (p, body) => request(p, { method: "PUT", body }),
  patch: (p, body) => request(p, { method: "PATCH", body }),
  del: (p) => request(p, { method: "DELETE" }),
  upload: (p, formData) => request(p, { method: "POST", body: formData, isForm: true }),
};

// 로그인은 토큰 없이 호출
export async function login(password) {
  const res = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof data.detail === "string" ? data.detail : "로그인에 실패했습니다.");
  }
  setToken(data.token);
  return data.token;
}

export async function checkToken() {
  const token = getToken();
  if (!token) return false;
  try {
    await request("/auth/check");
    return true;
  } catch {
    return false;
  }
}

/* 진행률이 필요한 업로드 — fetch 로는 진행 상황을 알 수 없어 XHR 을 쓴다.
   onProgress 에는 0~100 사이의 정수가 전달된다. */
export function uploadWithProgress(path, formData, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${BASE}${path}`);

    const token = getToken();
    if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);

    xhr.upload.onprogress = (e) => {
      if (onProgress && e.lengthComputable) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };

    xhr.onload = () => {
      if (xhr.status === 401) {
        redirectToLogin();
        reject(new Error("로그인이 필요합니다."));
        return;
      }
      let data = {};
      try {
        data = JSON.parse(xhr.responseText || "{}");
      } catch {
        data = {};
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(data);
      } else {
        reject(
          new Error(
            typeof data.detail === "string" ? data.detail : "업로드에 실패했습니다."
          )
        );
      }
    };

    xhr.onerror = () => reject(new Error("네트워크 오류로 업로드하지 못했습니다."));
    xhr.onabort = () => reject(new Error("업로드가 취소되었습니다."));

    xhr.send(formData);
  });
}
